import { render } from "./InstructionsText.vue?vue&type=template&id=85be5ee6&scoped=true"
const script = {}

import "./InstructionsText.vue?vue&type=style&index=0&id=85be5ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85be5ee6"]])

export default __exports__